import React, { FormEvent } from 'react'
import { Modal } from '@entur/modal'
import { SecondaryButton, NegativeButton } from '@entur/button'
import { useToast } from '@entur/alert'
import { Paragraph } from '@entur/typography'
import { FetchState, FipTicket } from '../../api-clients/api-types'
import { useApi } from '../../api-clients/client-hooks'
import { patchFIPTickets } from '../../api-clients/eba-clients'
import { trackEvent } from '../../utils/tracking-utils'
import { ModalErrorAlert } from '../modal/modal-error-alert'
import { useEmployee } from '../../contexts/employee-context'

type DeleteFIPModalProps = {
  open?: boolean
  fipTicket: FipTicket
  close: (newTicket?: FipTicket) => void
}
const DeleteFIPModal: React.FC<DeleteFIPModalProps> = (props) => {
  const { addToast } = useToast()
  const { employee } = useEmployee()
  const [deleteResponse, deleteFipTicket] = useApi(patchFIPTickets, {
    successCallback: (data) => {
      addToast('FIP-kupong er slettet!')
      props.close(data)
    },
  })

  const patch = (e: FormEvent) => {
    e.preventDefault()
    trackEvent('Delete-FIP-Ticket', { category: 'FIP' })
    deleteFipTicket({
      id: `${props.fipTicket.ticketId}-${employee.id}`,
      body: { isDeleted: true },
    })
  }

  return (
    <Modal
      className="delete-fip-modal"
      data-cy="delete-fip-modal"
      open={props.open}
      title="Slette FIP-kupong"
      size="medium"
      onDismiss={() => props.close()}
    >
      <Paragraph className="spacing-medium">
        Er du sikker på at du vil slette FIP-kupong med billettnummer: {props.fipTicket.ticketNo} for "
        {props.fipTicket.surname}, {props.fipTicket.firstName}”?
      </Paragraph>
      <div className="spacing-top-extra-large5">
        {deleteResponse.status === FetchState.ERROR && <ModalErrorAlert title="Sletting feilet" />}

        <NegativeButton
          loading={deleteResponse.status === FetchState.LOADING}
          onClick={patch}
          className="spacing-right-medium"
          data-cy="delete-fip-modal-delete-button"
        >
          Slett FIP-kupong
        </NegativeButton>
        <SecondaryButton data-cy="delete-fip-modal-cancel-button" onClick={() => props.close()}>
          Avbryt sletting
        </SecondaryButton>
      </div>
    </Modal>
  )
}

export default DeleteFIPModal
